import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'

const BASE_URL = '/api/class-attendance-report-for-admins'

export default {
  namespaced: true,
  state: {
    ...baseState,
    edit_data: {},
    attendanceStatus: [],
    presentStatus: []
  },
  mutations: {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
      state.edit_data = data
    },
    SET_ATT_STATUS(state, data) {
      state.attendanceStatus = data
    },
    SET_PRESENT_STATUS(state, data) {
      state.presentStatus = data
    }
  },
  actions: {
    async fetch(context, attributes = {}) {
      let params = Object.assign({
        perPage: context.state.pagination.perPage,
          search: context.state.search,

        ...attributes
      })
      let response = await httpClient.get(`${BASE_URL}`, {
        params
      })
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    formViewModel(context, params = {}) {
      return httpClient.get(`${BASE_URL}/form-view-models`, { params })
    },
    update(context, { id, data }) {
      return httpClient.put(`${BASE_URL}/${id}`, data)
    },

    async dataBeforeCreate(context) {
      if (
        !context.state.attendanceStatus ||
        context.state.attendanceStatus.length === 0
      ) {
        const response = await httpClient.get(`${BASE_URL}/attendance-status`)
        context.commit('SET_ATT_STATUS', response.data.data)
      }
      if (
        !context.state.presentStatus ||
        context.state.presentStatus.length === 0
      ) {
        const response = await httpClient.get(`${BASE_URL}/present-status`)
        context.commit('SET_PRESENT_STATUS', response.data.data)
      }
    }
  }
}
